import { inject, injectable } from "inversify";
import { ChangeTrackingModel, ChangeTrackingTypes, ICPLChangeTrackingClient } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IChangeTrackingService {
  getChangeHistory(type: ChangeTrackingTypes, recordID: string): Promise<ChangeTrackingModel>;
}

@injectable()
export class ChangeTrackingService implements IChangeTrackingService {
  @inject(SERVICE_TYPES.CPLChangeTrackingClient) cplChangeTrackingClient!: ICPLChangeTrackingClient;

  async getChangeHistory(type: ChangeTrackingTypes, recordID: string): Promise<ChangeTrackingModel> {
    return this.cplChangeTrackingClient.getChangeHistory(type, recordID);
  }
}
